export const systemEventsRoutes = [
  {
    path: "/systemevents",
    component: () => import("@/views/SystemEvents/List.vue"),
  },
];
